export default {

    set_error: (state, payload)=> {
        state.futureDonates = payload
    },
}